function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 8,
  fill: "#EEF5FF"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_11939_10331)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.3334 12.5C18.8892 12.5 19.4442 12.7108 20.0001 13.1333C20.5559 12.7108 21.1109 12.5 21.6667 12.5H26.6667C27.1088 12.5 27.5327 12.6756 27.8453 12.9882C28.1578 13.3007 28.3334 13.7246 28.3334 14.1667V25C28.3334 25.442 28.1578 25.8659 27.8453 26.1785C27.5327 26.4911 27.1088 26.6667 26.6667 26.6667H20.8334C20.8334 27.1267 20.4584 27.5 20.0001 27.5C19.5417 27.5 19.1667 27.125 19.1667 26.6667H13.3334C12.8914 26.6667 12.4675 26.4911 12.1549 26.1785C11.8423 25.8659 11.6667 25.442 11.6667 25V14.1667C11.6667 13.7246 11.8423 13.3007 12.1549 12.9882C12.4675 12.6756 12.8914 12.5 13.3334 12.5H18.3334ZM18.3334 14.1667H13.3334V25H19.1667V15C19.1667 14.5417 18.7917 14.1667 18.3334 14.1667ZM26.6667 14.1667H21.6667C21.2084 14.1667 20.8334 14.5417 20.8334 15V25H26.6667V14.1667Z",
  fill: "#365DE6"
}));
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_11939_10331"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(10 10)"
})));
const SvgColoredBookOpen = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgColoredBookOpen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/colored-book-open.fd10bb89.svg";
export { ForwardRef as ReactComponent };